export const config = {
  maxSize: 2 * 1024 * 1000,
  maxCoverSize: 1024 * 700,
  mimeTypes: ['image/png', 'image/jpeg', 'image/jpg'],
};
